
import React from 'react';
import { MenuItemData } from './types';

interface NavigationGridProps {
  column1Items: MenuItemData[];
  column2Items: MenuItemData[];
  onLinkClick: (href: string, e: React.MouseEvent) => void;
}

export const NavigationGrid: React.FC<NavigationGridProps> = ({ 
  column1Items, 
  column2Items, 
  onLinkClick 
}) => {
  return (
    <div className="flex-[2] px-6 py-4 bg-white/90">
      <div className="mb-4">
        <h3 className="text-xl font-semibold text-gray-900 tracking-tight mb-1">Quick Navigation</h3>
        <p className="text-gray-500 text-sm">Essential links and resources</p>
      </div>

      {/* Two column layout with specific ordering */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
        {/* Column 1: Homepage, About Us, Blog */}
        <div className="space-y-3">
          {column1Items.map((item) => (
            <button
              key={item.name}
              onClick={(e) => onLinkClick(item.href, e)}
              className="group p-3 border border-gray-200 hover:border-blue-300 hover:bg-blue-50/50 transition-all duration-200 flex items-start gap-3 text-left w-full h-28"
            >
              <item.icon className="w-5 h-5 text-gray-600 group-hover:text-blue-600 mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-gray-900 group-hover:text-blue-700 text-lg">{item.name}</h4>
                <p className="text-xs text-gray-600 group-hover:text-gray-700 leading-relaxed">
                  {item.description}
                  {item.name === 'Blog' && <br />}
                </p>
              </div>
            </button>
          ))}
        </div>
        
        {/* Column 2: Careers, FAQ, Client Login */}
        <div className="space-y-3">
          {column2Items.map((item) => (
            <button
              key={item.name}
              onClick={(e) => onLinkClick(item.href, e)}
              className="group p-3 border border-gray-200 hover:border-blue-300 hover:bg-blue-50/50 transition-all duration-200 flex items-start gap-3 text-left w-full h-28"
            >
              <item.icon className="w-5 h-5 text-gray-600 group-hover:text-blue-600 mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-gray-900 group-hover:text-blue-700 text-lg">{item.name}</h4>
                <p className="text-xs text-gray-600 group-hover:text-gray-700 leading-relaxed">
                  {item.description}
                  {item.name === 'Client Login' && <br />}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
